import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import "../Components/CreateClientPage/Experts.css";
import "../Components/CreateClientPage/Defendants.css";
import {
  formatDate,
  formatCalendarDate,
  formatPhoneNumber,
  getAge,
  getToken,
  setCaseId,
  setClientId,
} from "../Utils/helper";
import Footer from "../Components/Footer/Footer";
import CommonFooter from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import ActionBarImg from "../../public/BP_resources/images/icon/client-icon-color.svg";
import CreateNewClientHeader from "../Components/CreateClientPage/CreateClientHeader";
// import NewClient from "../Components/CreateClientPage/new-client";
// import NewCaseForExistingClient from "../Components/CreateClientPage/new-existing-client";
// import NewClientForExistingCase from "../Components/CreateClientPage/new-client-existing-case";
import IntakeReporting from "../Components/CreateClientPage/intake-reporting";
import IncomingReferrals from "../Components/CreateClientPage/incoming-referrals";
import AddNewCase from "../Components/CreateClientPage/add-new-case";
import IncomingLeads from "../Components/CreateClientPage/incoming-leads/IncomingLeads";
import incidentIcon from "../assets/images/incident.svg";
import birthdayIcon from "../assets/images/birthdayicon.svg";
import api from "../api/api";
import { fetchCurrentCase, setHeaderSummary } from "../Redux/header/headerDataSlice";
import { fetchCaseSummary, fetchHeaderSummary } from "../api/case";
import { fetchAllPages, setCaseSummary } from "../Redux/caseData/caseDataSlice";
import { setHeaderName } from "../Redux/header_name/action";
import resetClientStore from "../Redux/resetStore";
import { FIRM_SETTINGS_PATH } from "../Routes/routeAccessPolicy.mjs";

const toIncidentDateInputValue = (value) => {
  if (!value) return "";
  const s = String(value).trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
  const us = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (us) {
    return `${us[3]}-${us[1].padStart(2, "0")}-${us[2].padStart(2, "0")}`;
  }
  return s;
};

//RK ::2024-04-07 11-31pm
function CreateClientPag() {
  const origin = process.env.REACT_APP_BACKEND_URL;
  const loggedInInfo = useSelector((state) => state.loggedInfo.loggedInInfo);
  const isFreePlan = loggedInInfo?.is_paid_plan === false;
  const isFirmAdmin = loggedInInfo?.is_firm_admin === true;
  const [activeTab, setActiveTab] = useState(() =>
    isFreePlan ? "incoming-referrals" : "add-new-case"
  );
  const [subActiveTab, setSubActiveTab] = useState("new-client");
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showFreePlanPopup, setShowFreePlanPopup] = useState(false);
  const [freePlanPopupTimer, setFreePlanPopupTimer] = useState(10);
  const [_showNormal, setShowNormal] = useState(true);
  const [storeLink, setStoreLink] = useState("");
  // One API
  const [fieldStates, setFieldStates] = useState({});
  const [sourceTypes, setSourceTypes] = useState([]);
  const [sourceCategories, setSourceCategories] = useState([]);
  const [caseSources, setCaseSources] = useState([]);

  // Second API
  const [caseTypes, setCaseTypes] = useState([]);
  const [insuranceTypes, setInsuranceTypes] = useState([]);
  const [insuranceNewTypes, setInsuranceNewTypes] = useState([]);
  const [defendantTypes, setDefendantTypes] = useState([]);
  const [reportingagencyTypes, setReportingagencyTypes] = useState([]);
  const [state, setState] = useState([]);

  // States
  const [homeStateIntake, setHomeStateIntake] = useState(null);
  const [homeStateClient, setHomeStateClient] = useState(null);
  const [homeStateDefendant, setHomeStateDefendant] = useState(null);
  const [homeStateSource, setHomeStateSource] = useState(null);

  const [pendingLeadData, setPendingLeadData] = useState(null);
  const [pendingLeadAvailable, setPendingLeadAvailable] = useState(false);
  const [firstTime, setFirstTime] = useState(false);
  const storedLeadData = useMemo(() => JSON.parse(localStorage.getItem("LeadData")), []);
  const [pendingMappedData, setPendingMappedData] = useState(null);
  const [variableOrder, setVariableOrder] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const sidebarItems = [
    { id: "add-new-case", name: "Add New Case" },
    { id: "intake-reporting", name: "Intake Reporting" },

    { id: "incoming-leads", name: "New Leads" },
    { id: "incoming-referrals", name: "Clients Added From TreatmentFirst Providers" },
  ];

  const handleTabChange = (id) => {
    if (isFreePlan && id !== "incoming-referrals") {
      setShowFreePlanPopup(true);
      return;
    }

    setActiveTab(id);
    setFirstTime(false);
    if (storedLeadData && subActiveTab === storedLeadData.LeadActiveTab) {
      return;
    }
  };

  const handleUpgradeAccount = () => {
    setShowFreePlanPopup(false);
    navigate(`${FIRM_SETTINGS_PATH}?tab_id=account`);
  };

  useEffect(() => {
    if (isFreePlan) {
      setActiveTab("incoming-referrals");
    }
  }, [isFreePlan]);

  useEffect(() => {
    if (!showFreePlanPopup) return undefined;

    setFreePlanPopupTimer(10);

    const countdownTimer = window.setInterval(() => {
      setFreePlanPopupTimer((previousTimer) => Math.max(previousTimer - 1, 0));
    }, 1000);

    const autoCloseTimer = window.setTimeout(() => {
      setShowFreePlanPopup(false);
    }, 10000);

    return () => {
      window.clearInterval(countdownTimer);
      window.clearTimeout(autoCloseTimer);
    };
  }, [showFreePlanPopup]);

  const fetchPendingData = async (id = 0) => {
    try {
      const response = await axios.get(`${origin}/api/firmsetting-page/pending-lead/`, {
        headers: {
          Authorization: getToken(),
        },
      });
      if (response.status === 200) {
        const result = response.data;
        setPendingLeadData(result?.data);
        setVariableOrder(result.variable_order || []);

        const mappedData = () => {
          const mapped = result?.mapped_data || {};
          setPendingMappedData(mapped);
          const filteredData = Object.fromEntries(
            Object.entries(mapped).filter(([_, value]) => value !== null && value !== "")
          );
          const sharedFields = {
            ...filteredData,
            client_incident_date: toIncidentDateInputValue(mapped.incident_date),
            client_case_type: mapped.case_type || "",
            client_phone: mapped.client_phone_number || "",
            client_zip: mapped.client_zip_code || "",
            lead_id: result.data.id,
          };
          setFormData((prev) => ({
            ...prev,
            "new-client": {
              ...prev["new-client"],
              ...sharedFields,
            },
            "existing-client": {
              ...prev["existing-client"],
              ...sharedFields,
            },
            "new-client-existing-case": {
              ...prev["new-client-existing-case"],
              ...sharedFields,
            },
          }));
        };

        if (id > 0) {
          setFirstTime(true);
          setPendingLeadAvailable(true);
          mappedData();
        }

        if (storedLeadData.LeadId === result.data?.id) {
          setPendingLeadAvailable(true);
          mappedData();
        }
      } else {
        throw new Error("Failed to fetch data: Unexpected status code");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (storedLeadData) {
      fetchPendingData(0);
    }
  }, []);

  // useEffect(() => {
  //   fetchShakespeareStatus(caseId, "Inbox", dispatch);
  // }, [caseId, dispatch]);

  useEffect(() => {
    if (pendingMappedData && caseTypes?.length > 0) {
      const caseTypeName = pendingMappedData["Case Type"];
      if (caseTypeName) {
        let matchedId = null;
        let matchedCategory = null;

        for (const category of caseTypes) {
          const foundType = category.case_types?.find(
            (ct) => ct.name.toLowerCase() === caseTypeName.toLowerCase()
          );
          if (foundType) {
            matchedId = foundType.id;
            matchedCategory = category.id;
            break;
          }
        }

        if (matchedId && matchedCategory) {
          setFormData((prev) => ({
            ...prev,
            "new-client": {
              ...prev["new-client"],
              client_case_type: matchedId,
              client_case_category: matchedCategory,
            },
            "existing-client": {
              ...prev["existing-client"],
              client_case_type: matchedId,
              client_case_category: matchedCategory,
            },
            // "new-client-existing-case": {
            //   ...prev["new-client-existing-case"],
            //   client_case_type: matchedId,
            //   client_case_category: matchedCategory,
            // },
          }));
        }
      }
    }
  }, [pendingMappedData, caseTypes]);

  const [formData, setFormData] = useState({
    // new client new case
    "new-client": {
      // intake tab
      intake_jurisdiction: "",
      intake_venue_county: "",

      // client
      client_id: 0,
      client_first_name: "",
      client_middle_name: "",
      client_last_name: "",
      client_dob: "",
      client_phone: "",
      client_email: "",
      client_case_type: 0,
      client_case_category: 1,
      client_incident_date: "",
      client_address1: "",
      client_address2: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      client_insurance: 0,
      client_insurance_type: 0,
      client_policy_number: "",
      client_claim_number: "",
      client_insurance_company_id: 0,
      client_insurance_adjuster_id: 0,
      client_company_name: "",
      client_company_address1: "",
      client_company_address2: "",
      client_company_email: "",
      client_company_phone: "",
      client_company_city: "",
      client_company_state: "",
      client_company_zip: "",
      client_company_fax: "",
      client_company_extension_field: "",
      client_company_website: "",

      //
      client_adjuster_first_name: "",
      client_adjuster_last_name: "",
      client_adjuster_address1: "",
      client_adjuster_address2: "",
      client_adjuster_email: "",
      client_adjuster_phone: "",
      client_adjuster_city: "",
      client_adjuster_state: "",
      client_adjuster_zip: "",
      client_adjuster_fax: "",
      client_adjuster_extension_field: "",
      client_adjuster_website: "",

      // defendant
      case_id: 0,

      defendant_first_name: "",
      defendant_middle_name: "",
      defendant_last_name: "",
      defendant_phone: "",
      defendant_email: "",
      defendant_address1: "",
      defendant_address2: "",
      defendant_city: "",
      defendant_state: "",
      defendant_zip: "",
      defendant_insurance: 0,
      defendant_insurance_type: 0,
      defendant_type: 1,
      defendant_policy_number: "",
      defendant_claim_number: "",
      defendant_report_number: "",
      defendant_reporting_agency: "",
      defendant_entity_name: "",
      defendant_company_id: 0,
      defendant_adjuster_id: 0,
      defendant_company_name: "",
      defendant_company_address1: "",
      defendant_company_address2: "",
      defendant_company_email: "",
      defendant_company_phone: "",
      defendant_company_city: "",
      defendant_company_state: "",
      defendant_company_zip: "",
      defendant_company_fax: "",
      defendant_company_extension_field: "",
      defendant_company_website: "",
      defendant_adjuster_first_name: "",
      defendant_adjuster_last_name: "",
      defendant_adjuster_address1: "",
      defendant_adjuster_address2: "",
      defendant_adjuster_email: "",
      defendant_adjuster_phone: "",
      defendant_adjuster_city: "",
      defendant_adjuster_state: "",
      defendant_adjuster_zip: "",
      defendant_adjuster_fax: "",
      defendant_adjuster_extension_field: "",
      defendant_adjuster_website: "",
      defendant_report_name: "",
      defendant_report_address1: "",
      defendant_report_address2: "",
      defendant_report_email: "",
      defendant_report_phone: "",
      defendant_report_city: "",
      defendant_report_state: "",
      defendant_report_zip: "",
      defendant_report_fax: "",
      defendant_report_extension_field: "",
      defendant_report_website: "",
      // source
      source: [],
      // notes
      notes: "",
      lead_id: null,
    },

    // existing client new case
    "existing-client": {
      // intake tab
      // intake_venue_state: "",
      // intake_jurisdiction: "",
      // intake_venue_county: "",
      // intake_client_address1: "",
      // intake_client_address2: "",

      // client
      client_id: 0,
      // client_first_name: "",
      // client_last_name: "",
      // client_dob: "",
      client_case_category: 1,
      client_case_type: 0,
      client_incident_date: "",
      // client_phone_number: "",

      // source
      source_type: 0,
      source_category: 0,
      source_name: 0,
      source_date: "",
      source_time: "",
      source_location: "",
      source_address1: "",
      source_address2: "",
      source_city: "",
      source_state: "",
      source_zip: "",

      // defendant
      defendant_first_name: "",
      defendant_middle_name: "",
      defendant_last_name: "",
      defendant_phone: "",
      defendant_email: "",
      defendant_address1: "",
      defendant_address2: "",
      defendant_city: "",
      defendant_state: "",
      defendant_zip: "",
      defendant_insurance: 0,
      defendant_insurance_type: 0,
      defendant_policy_number: "",
      defendant_claim_number: "",
      defendant_report_number: "",
      defendant_reporting_agency: "",
      defendant_type: 1,
      defendant_entity_name: "",
      defendant_company_id: 0,
      defendant_adjuster_id: 0,
      defendant_company_name: "",
      defendant_company_address1: "",
      defendant_company_address2: "",
      defendant_company_email: "",
      defendant_company_phone: "",
      defendant_company_city: "",
      defendant_company_state: "",
      defendant_company_zip: "",
      defendant_company_fax: "",
      defendant_company_extension_field: "",
      defendant_company_website: "",
      defendant_adjuster_first_name: "",
      defendant_adjuster_last_name: "",
      defendant_adjuster_address1: "",
      defendant_adjuster_address2: "",
      defendant_adjuster_email: "",
      defendant_adjuster_phone: "",
      defendant_adjuster_city: "",
      defendant_adjuster_state: "",
      defendant_adjuster_zip: "",
      defendant_adjuster_fax: "",
      defendant_adjuster_extension_field: "",
      defendant_adjuster_website: "",
      defendant_report_name: "",
      defendant_report_address1: "",
      defendant_report_address2: "",
      defendant_report_email: "",
      defendant_report_phone: "",
      defendant_report_city: "",
      defendant_report_state: "",
      defendant_report_zip: "",
      defendant_report_fax: "",
      defendant_report_extension_field: "",
      defendant_report_website: "",
      // notes
      notes: "",
      lead_id: null,
    },

    // new client existing case
    "new-client-existing-case": {
      // intake tab
      // intake_jurisdiction: "",
      // intake_venue_county: "",

      // client
      client_first_name: "",
      client_middle_name: "",
      client_last_name: "",
      client_dob: "",
      client_phone: "",
      client_email: "",
      client_address1: "",
      client_address2: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      client_insurance: 0,
      client_insurance_type: 0,
      client_policy_number: "",
      client_claim_number: "",
      client_insurance_company_id: 0,
      client_insurance_adjuster_id: 0,
      client_company_name: "",
      client_company_address1: "",
      client_company_address2: "",
      client_company_email: "",
      client_company_phone: "",
      client_company_city: "",
      client_company_state: "",
      client_company_zip: "",
      client_company_fax: "",
      client_company_extension_field: "",
      client_company_website: "",
      client_adjuster_first_name: "",
      client_adjuster_last_name: "",
      client_adjuster_address1: "",
      client_adjuster_address2: "",
      client_adjuster_email: "",
      client_adjuster_phone: "",
      client_adjuster_city: "",
      client_adjuster_state: "",
      client_adjuster_zip: "",
      client_adjuster_fax: "",
      client_adjuster_extension_field: "",
      client_adjuster_website: "",
      // from
      case_id: 0,
      client_incident_date: "",

      // source
      source_type: 0,
      source_category: 0,
      source_name: 0,
      source_date: "",
      source_time: "",
      source_location: "",
      source_address1: "",
      source_address2: "",
      source_city: "",
      source_state: "",
      source_zip: "",

      // notes
      notes: "",
      lead_id: null,
    },
  });

  const handleInputChange = (tab, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [tab]: {
        ...prevData[tab],
        [field]: value,
      },
    }));

    // if (field === "client_email" || field === "defendant_email") {
    //   // Validate email based on field (client or defendant)
    //   setEmailValid((prevValid) => ({
    //     ...prevValid,
    //     [field]: emailRegex.test(value),
    //   }));
    // }
  };

  const fetchCaseTypes = async () => {
    try {
      const response = await axios.get(`${origin}/api/get_case_types/`, {
        headers: {
          Authorization: getToken(),
        },
      });

      if (response.status === 200) {
        const data = await response.data;
        setCaseTypes(data.case_type_categories);
        setInsuranceTypes(data.insurance_companies);
        setInsuranceNewTypes(data.insurance_types);
        setDefendantTypes(data.defendant_types);
        setReportingagencyTypes(data.reporting_agencies);
        const sortedStates = data.states.sort((a, b) => a.name.localeCompare(b.name));
        setState(sortedStates);
        // setState(data.states);
      }
    } catch (error) {
      console.error("Error fetching case types:", error);
    }
  };

  useEffect(() => {
    const fetchFieldSettings = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${origin}/api/firm_enabled_fields/`, {
          headers: {
            Authorization: getToken(),
          },
        });
        if (response.status === 200) {
          const data = response.data;
          setFieldStates(data.firm_field_settings.field_settings);

          const { source_types, source_categories, case_sources } = data;
          setSourceTypes(source_types);
          setSourceCategories(source_categories);
          setCaseSources(case_sources);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching field settings:", error);
        setLoading(false);
      }
    };

    const loadData = async () => {
      try {
        await Promise.all([fetchFieldSettings(), fetchCaseTypes()]);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    loadData();
  }, []);

  const [emailValid, setEmailValid] = useState({
    client_email: true,
    defendant_email: true,
  });

  const [phoneValid, setPhoneValid] = useState({
    client_phone: true,
    defendant_phone: true,
  });

  const handleSave = async () => {
    const storedLeadDataNew = JSON.parse(localStorage.getItem("LeadData"));

    const apiEndpoints = {
      "new-client": `${origin}/api/new_client_new_case/`,
      "existing-client": `${origin}/api/new_case_existing_client/`,
      "new-client-existing-case": `${origin}/api/new_client_existing_case/`,
    };

    const tabKey = activeTab === "add-new-case" ? subActiveTab : activeTab;

    const endpoint = apiEndpoints[tabKey];
    // const dataToSave = formData[tabKey];
    const dataToSave = {
      ...formData[tabKey],
      ...(storedLeadDataNew &&
      subActiveTab === storedLeadDataNew.LeadActiveTab &&
      pendingLeadAvailable
        ? { lead_id: pendingLeadData.id }
        : { lead_id: null }),
    };

    if (dataToSave.client_incident_date) {
      dataToSave.client_incident_date = toIncidentDateInputValue(dataToSave.client_incident_date);
    }

    if (!endpoint) {
      console.error("No endpoint defined for the active tab");
      return;
    }

    // New Section
    if (
      tabKey === "new-client" &&
      dataToSave.client_id !== 0 &&
      dataToSave.client_id !== undefined
    ) {
      const fieldsToRemove = [
        "intake_jurisdiction",
        "intake_venue_county",
        "client_first_name",
        "client_middle_name",
        "client_last_name",
        "client_phone_number",
        "client_dob",
        "client_phone",
        "client_email",
        "client_address1",
        "client_address2",
        "client_city",
        "client_state",
        "client_zip",
        "client_insurance",
        "client_insurance_type",
        "client_policy_number",
        "client_claim_number",
        "defendant_type",
      ];
      fieldsToRemove.forEach((field) => delete dataToSave[field]);
    } else if (
      tabKey === "new-client" &&
      (dataToSave.client_id === 0 || dataToSave.client_id === undefined)
    ) {
      delete dataToSave.client_id;
    }

    if (tabKey === "new-client" && dataToSave.case_id !== 0 && dataToSave.case_id !== undefined) {
      const caseFieldsToRemove = [
        "defendant_first_name",
        "defendant_middle_name",
        "defendant_last_name",
        "defendant_phone",
        "defendant_email",
        "defendant_address1",
        "defendant_address2",
        "defendant_city",
        "defendant_state",
        "defendant_zip",
        "defendant_insurance",
        "defendant_insurance_type",
        "defendant_type",
        "defendant_policy_number",
        "defendant_claim_number",
        "defendant_report_number",
        "defendant_reporting_agency",
        "client_case_category",
        "client_case_type",
        "client_incident_date",
      ];
      caseFieldsToRemove.forEach((field) => delete dataToSave[field]);
    } else if (tabKey === "new-client" && dataToSave.case_id === 0) {
      delete dataToSave.case_id;
    }

    let filteredData;

    if (tabKey === "new-client" || tabKey === "new-client-existing-case") {
      filteredData = Object.fromEntries(
        Object.entries(dataToSave).filter(([key]) => {
          const fieldMappings = {
            jurisdiction: ["intake_jurisdiction"],
            venue_county: ["intake_venue_county"],
          };

          for (const [fieldKey, formFields] of Object.entries(fieldMappings)) {
            if (formFields.includes(key)) {
              return fieldStates[fieldKey] !== false; // Include if enabled in fieldStates
            }
          }

          // Include all other fields by default
          return true;
        })
      );
    } else if (tabKey === "existing-client") {
      filteredData = Object.fromEntries(
        Object.entries(dataToSave).filter(([key]) => {
          const fieldMappings = {
            venue_state: ["intake_venue_state"],
            jurisdiction: ["intake_jurisdiction"],
            venue_county: ["intake_venue_county"],
            client_address: ["intake_client_address1", "intake_client_address2"],
          };

          for (const [fieldKey, formFields] of Object.entries(fieldMappings)) {
            if (formFields.includes(key)) {
              return fieldStates[fieldKey] !== false; // Include if enabled in fieldStates
            }
          }

          // Include all other fields by default
          return true;
        })
      );
    } else {
      // Default fallback
      filteredData = dataToSave;
    }

    let excludedFields = [];
    if (tabKey === "new-client") {
      excludedFields = [
        "client_email",
        "client_address2",
        "client_middle_name",
        "client_city",
        "client_zip",
        "client_insurance",
        "client_insurance_type",
        "intake_client_address2",
        "client_policy_number",
        "client_claim_number",
        "defendant_first_name",
        "defendant_middle_name",
        "defendant_last_name",
        "defendant_phone",
        "defendant_email",
        "defendant_address1",
        "defendant_address2",
        "defendant_city",
        "defendant_state",
        "defendant_zip",
        "defendant_insurance",
        "defendant_insurance_type",
        "defendant_type",
        "defendant_policy_number",
        "defendant_claim_number",
        "defendant_report_number",
        "defendant_reporting_agency",
        "source_type",
        "source_category",
        "source_name",
        "source_date",
        "source_time",
        "source_location",
        "source_address1",
        "source_address2",
        "source_city",
        "source_state",
        "source_zip",
        "notes",
        "lead_id",
      ];
    } else if (tabKey === "existing-client") {
      excludedFields = [
        "intake_venue_state",
        "intake_jurisdiction",
        "intake_venue_county",
        "intake_client_address1",
        "intake_client_address2",
        "client_city",
        "client_state",
        "client_zip",
        "client_insurance",
        "client_insurance_type",
        "client_policy_number",
        "client_claim_number",
        "client_email",
        "client_phone_number",
        "client_dob",
        "client_address1",
        "client_address2",
        "client_city",
        "client_zip",
        "client_insurance",
        "client_policy_number",
        "client_claim_number",
        "defendant_first_name",
        "defendant_middle_name",
        "defendant_last_name",
        "defendant_phone",
        "defendant_email",
        "defendant_address1",
        "defendant_address2",
        "defendant_city",
        "defendant_state",
        "defendant_zip",
        "defendant_insurance",
        "defendant_insurance_type",
        "defendant_policy_number",
        "defendant_claim_number",
        "defendant_report_number",
        "defendant_reporting_agency",
        "source_type",
        "source_category",
        "source_name",
        "source_date",
        "source_time",
        "source_location",
        "source_address1",
        "source_address2",
        "source_city",
        "source_state",
        "source_zip",
        "notes",
        "defendant_type",
        "lead_id",
      ];
    } else if (tabKey === "new-client-existing-case") {
      excludedFields = [
        "intake_jurisdiction",
        "intake_venue_county",
        // "intake_client_address1 + state",
        "intake_client_address2",
        "client_middle_name",
        "client_city",
        "client_zip",
        "client_insurance",
        "client_insurance_type",
        "client_policy_number",
        "client_claim_number",
        "client_email",
        "client_address2",
        "client_city",
        "client_zip",
        "client_insurance",
        "client_policy_number",
        "client_claim_number",
        "defendant_first_name",
        "defendant_middle_name",
        "defendant_last_name",
        "defendant_phone",
        "defendant_email",
        "defendant_address1",
        "defendant_address2",
        "defendant_city",
        "defendant_state",
        "defendant_zip",
        "defendant_insurance",
        "defendant_insurance_type",
        "defendant_policy_number",
        "defendant_claim_number",
        "defendant_report_number",
        "defendant_reporting_agency",
        "source_type",
        "source_category",
        "source_name",
        "source_date",
        "source_time",
        "source_location",
        "source_address1",
        "source_address2",
        "source_city",
        "source_state",
        "source_zip",
        "notes",
        "defendant_type",
        "lead_id",
        "client_case_type",
      ];
    }

    for (const field in filteredData) {
      // Skip the excluded fields
      if (excludedFields.includes(field)) {
        continue;
      }

      // Check if the field value is 0 or an empty string
      // if (filteredData[field] === 0 || filteredData[field] === "") {
      //   toast.info("Please fill the required fields");
      //   return;
      // }
    }

    try {
      setLoadingSave(true);
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        body: JSON.stringify(filteredData),
      });
      if (response.ok) {
        const result = await response.json();
        if (storedLeadData && subActiveTab === storedLeadData.LeadActiveTab) {
          localStorage.removeItem("LeadData");
        }
        setStoreLink(result);
        setLoadingSave(false);
        setShowPopup(true);
        setShowNormal(false);
      } else {
        console.error("Failed to save data:", response.statusText);
        setLoadingSave(false);
        toast.error("Failed to save the data");
      }
    } catch (error) {
      console.error("Error during save operation:", error);
      setLoadingSave(false);
      toast.error("Failed to save the data");
    }
  };

  const renderActiveTabContent = () => {
    switch (activeTab) {
      case "add-new-case":
        return (
          <AddNewCase
            subActiveTab={subActiveTab}
            setSubActiveTab={setSubActiveTab}
            newClientData={formData["new-client"]}
            existingClientData={formData["existing-client"]}
            existingCaseData={formData["new-client-existing-case"]}
            newClientOnChange={(field, value) => handleInputChange("new-client", field, value)}
            existingClientOnChange={(field, value) =>
              handleInputChange("existing-client", field, value)
            }
            existingCaseOnChange={(field, value) =>
              handleInputChange("new-client-existing-case", field, value)
            }
            isEmailValid={emailValid}
            setEmailValid={setEmailValid}
            isPhoneValid={phoneValid}
            setPhoneValid={setPhoneValid}
            loading={loading}
            setLoading={setLoading}
            fieldStates={fieldStates}
            sourceTypes={sourceTypes}
            sourceCategories={sourceCategories}
            caseSources={caseSources}
            caseTypes={caseTypes}
            insuranceTypes={insuranceTypes}
            insuranceNewTypes={insuranceNewTypes}
            defendantTypes={defendantTypes}
            reportingagencyTypes={reportingagencyTypes}
            state={state}
            homeStateIntake={homeStateIntake}
            setHomeStateIntake={setHomeStateIntake}
            homeStateClient={homeStateClient}
            setHomeStateClient={setHomeStateClient}
            homeStateDefendant={homeStateDefendant}
            setHomeStateDefendant={setHomeStateDefendant}
            homeStateSource={homeStateSource}
            setHomeStateSource={setHomeStateSource}
            setFirstTime={setFirstTime}
            pendingLeadData={pendingLeadData}
            pendingLeadAvailable={pendingLeadAvailable}
            storedLeadData={storedLeadData}
            setStoreLink={setStoreLink}
            loadingSave={loadingSave}
            setLoadingSave={setLoadingSave}
            setShowPopup={setShowPopup}
            setShowNormal={setShowNormal}
          />
        );
      case "intake-reporting":
        return <IntakeReporting />;
      case "incoming-referrals":
        return <IncomingReferrals />;
      case "incoming-leads":
        return (
          <IncomingLeads
            setActiveTab={setActiveTab}
            setSubActiveTab={setSubActiveTab}
            fetchPendingData={fetchPendingData}
          />
        );
    }
  };

  const getSelectedCaseType = () => {
    const caseTypeId = formData[subActiveTab]?.client_case_type;
    if (!caseTypeId || !caseTypes?.length) return null;

    for (const category of caseTypes) {
      const found = category.case_types?.find((ct) => ct.id === caseTypeId);
      if (found) return found;
    }
    return null;
  };

  const handleClosePopup = () => {
    setPendingLeadAvailable(false);
    handleClose();
    setShowNormal(true);
    setShowPopup(false);
  };

  const handleSavePopup = async () => {
    try {
      setLoading(true);

      // Keep the submitted values until the follow-up request succeeds. If this
      // request fails, the confirmation remains open and the user can retry it
      // without losing the original form payload.
      await api.get(`/api/switch_client/${storeLink.client_id}/${storeLink.case_id}/1/`);
      await resetClientStore();

      setClientId(storeLink?.client_id);
      setCaseId(storeLink?.case_id);

      const [currentCase, headerSummary, caseSummary, pages] = await Promise.all([
        dispatch(fetchCurrentCase(storeLink.client_id, storeLink.case_id)),
        fetchHeaderSummary(storeLink.client_id, storeLink.case_id),
        fetchCaseSummary(storeLink.client_id, storeLink.case_id),
        dispatch(fetchAllPages(storeLink.case_id, true)),
      ]);

      // These Redux requests report a failure by resolving with undefined.
      if (currentCase === undefined || pages === undefined) {
        throw new Error("Failed to load the newly created case.");
      }

      dispatch(setHeaderSummary(headerSummary));
      dispatch(setCaseSummary(caseSummary));
      dispatch(setHeaderName("Case"));

      handleClose();
      setShowNormal(true);
      setShowPopup(false);
      navigate("/search", {
        replace: true,
      });
    } catch (error) {
      console.error("Failed to open the newly created case:", error);
      toast.error(
        error.response?.data?.error ||
          error.response?.data?.detail ||
          "Failed to open the newly created case. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    document.body.classList.remove("modal-open");
    // cleaning on closing
    const cleanedData = resetFormData(formData);
    setFormData(cleanedData);
  };

  const resetFormData = (data) => {
    setHomeStateIntake(null);
    setHomeStateClient(null);
    setHomeStateDefendant(null);
    setHomeStateSource(null);

    const excludeKeys = new Set(["client_case_type", "client_case_category"]);

    // Recursively reset all values
    const resetObject = (obj) => {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          if (excludeKeys.has(key)) {
            return [key, value];
          }

          if (typeof value === "object" && value !== null) {
            return [key, resetObject(value)];
          }
          if (typeof value === "string") return [key, ""];
          if (typeof value === "number") return [key, 0];
          return [key, value]; // Handle other cases if necessary
        })
      );
    };

    return resetObject(data);
  };

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div
          className={`page-container ${activeTab === "incoming-referrals" ? "create-client-referrals-page" : ""}`}
        >
          <NavBar flaggedPageName="2" />
          <ActionBarComponent
            src={ActionBarImg}
            page_name={"Create Client"}
            buttons={[]}
            isChecklist={false}
          />

          <div
            className={`experts-main-container invisible-scrollbar ${activeTab === "incoming-referrals" ? "create-client-referrals-layout" : ""}`}
            style={
              activeTab === "incoming-referrals"
                ? undefined
                : {
                    overflowY: "auto",
                    // maxHeight: "100%",
                    // height: "100%",
                    height: !["incoming-referrals", "intake-reporting", "incoming-leads"].includes(
                      activeTab
                    )
                      ? "calc(100% - 170px)"
                      : "100%",
                    top: "165px",
                  }
            }
          >
            <CreateNewClientHeader
              sidebarItems={sidebarItems}
              activeTab={activeTab}
              handleTabChange={handleTabChange}
              isMain={true}
            />
            <div
              style={activeTab === "incoming-referrals" ? undefined : { minHeight: "400px" }}
              className={
                activeTab === "incoming-referrals" ? "create-client-referrals-content" : "m-t-5"
              }
            >
              {renderActiveTabContent()}
            </div>
            <div style={{ position: "relative", top: "0px" }} className="first-client-page">
              {!["incoming-referrals", "intake-reporting", "incoming-leads"].includes(activeTab) &&
                !["new-client", "existing-client", "new-client-existing-case"].includes(
                  subActiveTab
                ) && (
                  <div className="m-t-5 p-r-5 d-flex align-items-center justify-content-end">
                    <Button
                      variant="success"
                      onClick={handleSave}
                      className="height-25 d-flex align-items-center justify-content-center"
                      disabled={
                        loadingSave ||
                        !(emailValid.client_email && emailValid.defendant_email) ||
                        !(phoneValid.client_phone && phoneValid.defendant_phone)
                      }
                    >
                      {loadingSave ? "Saving" : "Save"}
                    </Button>
                  </div>
                )}

              {/* Table : showRow &&*/}
              {((pendingLeadAvailable &&
                activeTab === "add-new-case" &&
                subActiveTab === JSON.parse(localStorage.getItem("LeadData"))?.LeadActiveTab) ||
                firstTime) && (
                <table
                  className="table table-borderless table-striped table-earning has-height-25 fixed-table-header-notes-page mt-3"
                  id="table-x"
                >
                  <thead className="toolbar-fonts">
                    <tr id="tb-header">
                      <th className="note-col-2 x2 text-center">Name</th>
                      <th className="note-col-3 x2 text-center">Date</th>
                      <th className="notes-col note-col-5 x5 text-center">Text</th>
                      <th className="notes-col note-col-5 x5 text-center">Identified Variables</th>
                      <th className="note-col-2 x2 text-center">Case</th>
                      <th className="note-col-2 x2 text-center">Status</th>
                    </tr>
                  </thead>
                  <tbody id="table-body-cat" className="all_notes_tab fixed_column_width">
                    <tr style={{ height: "45px" }}>
                      <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                        {pendingLeadData?.for_text_source ? (
                          <>
                            <div>{pendingLeadData.for_text_source.name}</div>
                            <div>
                              {formatPhoneNumber(pendingLeadData.for_text_source.phone_number)}
                            </div>
                          </>
                        ) : pendingLeadData?.for_email_source ? (
                          <>
                            <div>{pendingLeadData.for_email_source.name}</div>
                            <div>{pendingLeadData.for_email_source.email}</div>
                            <div>{pendingLeadData.for_email_source.keywords || ""}</div>
                          </>
                        ) : (
                          <div>-</div>
                        )}
                      </td>
                      <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                        {formatDate(pendingLeadData?.date)}
                      </td>
                      <td
                        className="client_page_note_row hover-button-td notes-sec-color-black"
                        style={{
                          textAlign: "left",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          // verticalAlign: "top",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        {pendingLeadData?.text}
                      </td>
                      <td
                        className="client_page_note_row hover-button-td notes-sec-color-black"
                        style={{
                          textAlign: "center",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                        }}
                      >
                        <p style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                          {pendingLeadData?.identified_variables &&
                            variableOrder?.length > 0 &&
                            Object.keys(pendingLeadData?.identified_variables).length > 0 && (
                              <p>
                                {variableOrder.map((key) => {
                                  {
                                    /* if (!value) return null; */
                                  }
                                  if (!(key in pendingLeadData.identified_variables)) return null;
                                  const value = pendingLeadData.identified_variables[key];
                                  return (
                                    <p key={key}>
                                      <span className="identify-leads-name">{key}</span>: {value}
                                    </p>
                                  );
                                })}
                              </p>
                            )}
                        </p>
                      </td>
                      <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                        {pendingLeadData?.for_client && pendingLeadData?.for_case && (
                          <>
                            <div
                              className="d-flex height-25 align-items-center "
                              style={{
                                // height: "25px",
                                color: "black",
                                fontWeight: "600",
                                gap: "5px",
                              }}
                            >
                              {pendingLeadData?.for_client?.profile_pic_19p ? (
                                <span className="ic-avatar ic-19 has-cover-img sidebar-pic">
                                  <img
                                    src={pendingLeadData?.for_client?.profile_pic_19p}
                                    alt={pendingLeadData?.for_client?.first_name}
                                  />
                                </span>
                              ) : (
                                <span className="ic ic-avatar ic-19 has-avatar-icon has-cover-img sidebar-pic" />
                              )}
                              {`${pendingLeadData?.for_client?.first_name},`}{" "}
                              {pendingLeadData?.for_client?.last_name}
                            </div>
                            <div
                              className="d-flex height-25 align-items-center justify-content-start"
                              style={{
                                gap: "5px",
                              }}
                            >
                              <span className="d-flex align-items-center justify-content-center ic ic-19">
                                <img
                                  src={birthdayIcon}
                                  className="ic ic-19 d-flex align-items-center justify-content-center"
                                />
                              </span>
                              {formatCalendarDate(pendingLeadData.for_client?.birthday)},
                              <span
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                  color: "var(--primary)",
                                }}
                              >
                                Age
                              </span>
                              {getAge(pendingLeadData.for_client?.birthday)}
                            </div>
                            <div
                              style={{
                                gap: "5px",
                              }}
                              className="d-flex height-25 align-items-center justify-content-start"
                            >
                              <span className="d-flex align-items-center justify-content-center ic ic-19">
                                <img
                                  src={pendingLeadData?.for_case.case_type?.casetype_icon}
                                  className="ic ic-19 d-flex align-items-center justify-content-center"
                                />
                              </span>
                              {pendingLeadData?.for_case.case_type?.name}
                            </div>
                            <div
                              style={{
                                gap: "5px",
                              }}
                              className="d-flex height-25 align-items-center justify-content-start"
                            >
                              <span className="d-flex align-items-center justify-content-center ic ic-19">
                                <img
                                  src={incidentIcon}
                                  className="ic ic-19 d-flex align-items-center justify-content-center"
                                />
                              </span>
                              {formatCalendarDate(pendingLeadData.for_case.incident_date)}
                            </div>
                          </>
                        )}
                      </td>
                      <td className="td-autosize hover-button-td" style={{ textAlign: "center" }}>
                        {pendingLeadData?.status?.name}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <CommonFooter />

      {showFreePlanPopup && (
        <Modal
          show={showFreePlanPopup}
          onHide={() => setShowFreePlanPopup(false)}
          size="md"
          centered
        >
          <Modal.Header className="tfbp-modal-header justify-content-center text-center">
            <Modal.Title
              className="tfbp-modal-title"
              style={{
                textTransform: "uppercase",
              }}
            >
              Test-Drive Account: User Cannot Input New Cases
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-1 text-center">
            <p className="mb-1 text-center">
              Free Test-Drive accounts are limited to testing the program with clients input by
              providers from TreatmentFirst.com. Upgrade to a paid account to input your own
              clients.
            </p>
            <span
              style={{
                fontWeight: "600",
                color: "var(--primary)",
              }}
              className="whitespace-nowrap"
            >
              Popup will automatically close in {freePlanPopupTimer} seconds...
            </span>
          </Modal.Body>
          <Modal.Footer
            className="p-0 mt-0 padding-outside-btn-new-provider justify-content-center"
            style={{ borderTop: "none" }}
          >
            <Button
              className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
              variant="secondary"
              onClick={() => setShowFreePlanPopup(false)}
            >
              Close Now
            </Button>

            {isFirmAdmin && (
              <Button
                variant="primary"
                className="height-25 d-flex align-items-center justify-content-center"
                onClick={handleUpgradeAccount}
              >
                Upgrade Account
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      )}
      {/* // Other Modal */}
      {showPopup && (
        <Modal show={true} size="md" centered dialogClassName="newcasemodalhuz2">
          <Modal.Header
            style={{
              borderBottom: "0px",
            }}
            className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
          >
            <Modal.Title
              className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
              id="modal_title"
              style={{ fontSize: "14px", fontWeight: "600" }}
            >
              <span>Confirmation Message</span>

              {/* <div
                className="closeicon"
                onClick={handleClosePopup}
                style={{
                  marginBottom: "-10px",
                }}
              >
                <ClearOutlinedIcon />
              </div> */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-2">
            {/* Success message */}
            {subActiveTab === "new-client" && (
              <p style={{ fontSize: "1rem", marginBottom: "5px" }}>
                New Client with New Case has been created successfully.
              </p>
            )}
            {subActiveTab === "new-client-existing-case" && (
              <p style={{ fontSize: "1rem", marginBottom: "5px" }}>
                New Client for Existing Case has been created successfully.
              </p>
            )}
            {subActiveTab === "existing-client" && (
              <p style={{ fontSize: "1rem", marginBottom: "5px" }}>
                New Case for Existing Client has been created successfully.
              </p>
            )}

            {/* Client Details */}
            <div className="w-100" style={{ fontWeight: "600" }}>
              {/* Client Name */}
              <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                <i className="ic ic-avatar ic-16 has-avatar-icon" />
                <span>
                  {formData[subActiveTab]?.client_last_name}{" "}
                  {formData[subActiveTab]?.client_first_name}
                </span>
              </div>

              {/* Birthday & Age */}
              <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                <img src={birthdayIcon} alt="Birthday" style={{ width: "16px", height: "16px" }} />
                <span>{formatDate(formData[subActiveTab]?.client_dob)}</span>
                <span clasName="ps-3" style={{ color: "var(--primary-25" }}>
                  Age
                </span>
                <span>{getAge(formData[subActiveTab]?.client_dob)}</span>
              </div>

              {/* Case Type */}
              {subActiveTab !== "new-client-existing-case" && (
                <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                  {getSelectedCaseType()?.casetype_icon && (
                    <img
                      src={getSelectedCaseType()?.casetype_icon}
                      alt="Case Type"
                      style={{ width: "16px", height: "16px" }}
                    />
                  )}
                  <span>{getSelectedCaseType()?.name || "N/A"}</span>
                </div>
              )}

              {subActiveTab === "new-client-existing-case" && (
                <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                  {formData[subActiveTab]?.client_case_type?.casetype_icon && (
                    <img
                      src={formData[subActiveTab]?.client_case_type?.casetype_icon}
                      alt="Case Type"
                      style={{ width: "16px", height: "16px" }}
                    />
                  )}
                  <span>{formData[subActiveTab]?.client_case_type?.name || "N/A"}</span>
                </div>
              )}

              {/* Incident Date */}
              <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                <img src={incidentIcon} alt="Incident" style={{ width: "16px", height: "16px" }} />
                <span>{formatCalendarDate(formData[subActiveTab]?.client_incident_date)}</span>
              </div>
            </div>
          </Modal.Body>
          <div className="d-flex justify-content-between align-items-center p-b-5 p-r-5 p-l-5">
            <Button variant="secondary" className="py-0 px-2" onClick={handleClosePopup}>
              <p>Close and Continue</p>
              <p>with Current Case</p>
            </Button>
            <Button
              variant="success"
              className="text-center py-0 px-2"
              onClick={handleSavePopup}
              disabled={loading}
            >
              <p>Close and Open</p>
              <p>Newly Input Case</p>
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
}

export default CreateClientPag;
